/**
 * =============================================================================
 * wellness-finder.js 
 * =============================================================================
 *
 * Stub extension populated by the 'mp-page-panel-welnness-finder' section.
 * Only used for holding data.
 * =============================================================================
 */

var WellnessFinder = {
  data: {}
}

export default WellnessFinder